import React from 'react';
import { Navigate } from 'react-router-dom';
import { useGetOnboardingQuery } from '../../store/api/onboardingApi';
import { firstIncompleteStepPath } from './steps';

/**
 * Index route for /onboarding. Resolves onboarding state and redirects to the
 * first incomplete step, or to the dashboard when onboarding is completed.
 * This is the resume entry point hit after login.
 */
const OnboardingResume = () => {
  const { data, isLoading } = useGetOnboardingQuery();

  if (isLoading) {
    return (
      <section className="wiz-card" aria-busy="true">
        <div className="wiz-skeleton" style={{ width: '60%', marginBottom: 16 }} />
        <div className="wiz-skeleton block" />
      </section>
    );
  }

  const path = firstIncompleteStepPath(data);
  return <Navigate to={path || '/dashboard'} replace />;
};

export default OnboardingResume;
